import { StatusLinkPagamentoCelerEnum } from 'src/app/shared/models/pagamento-pix-celer-model';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PlanoEfetivado } from 'src/app/shared/models/plano-efetivado.model';
import { LinkPagamento } from 'src/app/shared/models/link-pagamento-model';
import { Router } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

export enum SegundaViaPlanoEfetivadoCheckoutType {
  PIX = 'PIX',
  BOLETO = 'BOLETO'
}

@Component({
  selector: 'app-plano-efetivado-card',
  templateUrl: './plano-efetivado-card.component.html',
  styleUrls: ['./plano-efetivado-card.component.scss']
})
export class PlanoEfetivadoCardComponent implements OnInit {

  @Input()
  planoEfetivado: PlanoEfetivado;

  @Input()
  mostrarBotaoDesistirAcordo: boolean;

  @Input()
  statusCeler: LinkPagamento | null;

  @Output()
  segundaVia = new EventEmitter<SegundaViaPlanoEfetivadoCheckoutType>();

  @Output()
  desistir = new EventEmitter<void>();

  @Input()
  elegivelPagamentoPix: boolean = false;

  StatusLinkPagamentoCelerEnum = StatusLinkPagamentoCelerEnum;

  checkoutType: SegundaViaPlanoEfetivadoCheckoutType = SegundaViaPlanoEfetivadoCheckoutType.PIX;

  SegundaViaPlanoEfetivadoCheckoutType = SegundaViaPlanoEfetivadoCheckoutType;

  constructor(
    private router: Router,
    private googleAnalyticsService: GoogleAnalyticsService
  ) { }

  ngOnInit(): void { }

  handleSegundaViaEntrada() {
    if (this.elegivelPagamentoPix) {
      this.segundaVia.emit(this.checkoutType);
      return;
    }

    this.segundaVia.emit(SegundaViaPlanoEfetivadoCheckoutType.BOLETO);
  }

  handleDesistirDoAcordo() {
    this.desistir.emit();
  }

  handleCheckoutType(checkoutType: 'pix' | 'boleto') {
    if (checkoutType === 'pix') {
      this.checkoutType = SegundaViaPlanoEfetivadoCheckoutType.PIX;
    }
    if (checkoutType === 'boleto') {
      this.checkoutType = SegundaViaPlanoEfetivadoCheckoutType.BOLETO;
    }
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: `pagar com ${this.checkoutType}`,
      context: 'portal reneg: renegociacao',
    });
  }

  get status() {
    if (this.statusCeler && this.statusCeler.statusLinkPagamento === StatusLinkPagamentoCelerEnum.PAGO) {
      return 'Em Processamento';
    }

    return 'Aguardando Pagamento';
  }

  get desabilitarAcoes() {
    return this.statusCeler?.statusLinkPagamento === StatusLinkPagamentoCelerEnum.PAGO;
  }

  get mostrarMensagemPrazoPagamento() {
    return !this.statusCeler || this.statusCeler?.statusLinkPagamento !== StatusLinkPagamentoCelerEnum.PAGO;
  }

  voltarParaContratos() {
    this.router.navigate(['/portal/contratos']);
  }

}
